import { useEffect, useMemo } from 'react';
import type { TourFrame } from '@carboncopyco/types';
import { Debug } from '@carboncopyco/utils';
import { setPlayableFrames } from '../../store';
import { useTourDispatch } from '../store';

const debug = Debug.extend('use-playable-frames');

export const usePlayableFrames = (
  uuid: string,
  frames: TourFrame[],
  isPreview: boolean
) => {
  const dispatch = useTourDispatch();

  const playableFrames = useMemo(() => {
    if (!frames || frames.length === 0 || frames[0].frameIndex !== 0) {
      return [];
    }

    return frames.filter(
      (frame) =>
        (isPreview && frame.isActive && !frame.isDisabled) ||
        (!isPreview && !frame.isDisabled)
    );
  }, [frames, isPreview]);

  useEffect(() => {
    dispatch(setPlayableFrames({ uuid, playableFrames }));
    debug({ playableFrames });
  }, [playableFrames, uuid, dispatch]);

  return playableFrames;
};
